import MagazineItem from "./MagazineItem";

export default MagazineItem;
